import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { BrandingProvider } from './hooks/useBranding'
import { I18nProvider } from './hooks/useI18n'
import PortalLayout from './components/PortalLayout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import MyMatters from './pages/MyMatters'
import MatterDetails from './pages/MatterDetails'
import MyDocuments from './pages/MyDocuments'
import MyInvoices from './pages/MyInvoices'
import Payments from './pages/Payments'
import SignDocument from './pages/SignDocument'
import Appointments from './pages/Appointments'
import Messages from './pages/Messages'
import Profile from './pages/Profile'
import TrustBalance from './pages/TrustBalance'
import PaymentHistory from './pages/PaymentHistory'
import Expenses from './pages/Expenses'
import Help from './pages/Help'
import ResetPassword from './pages/ResetPassword'

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function AppRoutes() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="matters" element={<MyMatters />} />
        <Route path="matters/:matterId" element={<MatterDetails />} />
        <Route path="documents" element={<MyDocuments />} />
        <Route path="invoices" element={<MyInvoices />} />
        <Route path="payments" element={<Payments />} />
        <Route path="sign/:signatureId" element={<SignDocument />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="messages" element={<Messages />} />
        <Route path="profile" element={<Profile />} />
        <Route path="trust" element={<TrustBalance />} />
        <Route path="payment-history" element={<PaymentHistory />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="help" element={<Help />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <I18nProvider>
      <BrandingProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrandingProvider>
    </I18nProvider>
  )
}

export default App
